import { defineComponent, ref } from 'vue';
import { Phone, Message, Location } from '@element-plus/icons-vue';
export default defineComponent({
  name: 'MobilePageFooter',
  components: {
    Phone,
    Message,
    Location
  },
  setup() {
    const footerData = ref([{
      type: '0',
      title: 'label13',
      list: ['label16', 'label17', 'label18', 'label19']
    }, {
      type: '0',
      title: 'label14',
      list: ['label20', 'label21', 'label22', 'label23', 'label24', 'label25']
    }, {
      type: '0',
      title: 'label15',
      list: ['label26']
    }]);
    return {
      footerData
    };
  }
});